import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { TertiaryButton } from '@enechain/ecloud-designsystem'

import {
  type SettlementDetailLanding,
  type SettlementDetailMarket,
  toSettlementDetailLandingState,
} from '~/models/settlementDetailLanding'
import { routePaths } from '~/routes/routePaths'

type Props = {
  landing: SettlementDetailLanding
}

const DESTINATION_PATH: Record<SettlementDetailMarket, string> = {
  spot: routePaths.biddingSpot.path,
  intraday: routePaths.biddingIntraday.path,
}

/**
 * 清算書の行の「詳細」 (AC-JST-009)。 清算書に含まれる取引の約定結果を、 市場の入札画面で
 * 開く。 開く日は `landing` が持ち、 タブやフィルターの初期状態は開いた先が決める。
 */
export const SettlementDetailButton = ({
  landing,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <TertiaryButton
      // [DS差異] 行アクションの文字は md (size="sm" の高さ・padding は保つ)。 根拠は
      // design/ui-feasibility/components/table.md の「詳細」 (32px・md)。 settlement.html は
      // 素の td に btn-sm (12px) を置いていて、 辞書の形とは違う。
      fontSize="md"
      onClick={() => {
        void navigate(DESTINATION_PATH[landing.market], {
          state: toSettlementDetailLandingState(landing),
        })
      }}
      paddingX={3}
      size="sm"
    >
      {t('page:jepxSettlement.action.detail')}
    </TertiaryButton>
  )
}
